import { createSlice } from '@reduxjs/toolkit'

export const darkModeSlice = createSlice({
  name: 'dark_mode',
  initialState: {
    value: true,
    userId: null
  },
  reducers: {
    setDarkMode: (state, data) => {
      state.value = data.payload.dark_mode
    },
    setDarkModeUserId: (state, data) => {
      state.userId = data.payload.user_id
    },
  },
})

// Action creators are generated for each case reducer function
export const { setDarkMode, setDarkModeUserId } = darkModeSlice.actions

export default darkModeSlice.reducer